import * as React from 'react';
import { Image, UIText2 } from '@cian/ui-kit';
import * as styles from './BankItem.css';

interface IBankItemProps {
  title: string;
  url: string;
  logo: string;
  onClick(): void;
}

export const BankItem: React.FC<IBankItemProps> = ({ title, url, logo, onClick }) => {
  return (
    <a href={url} className={styles['link']} onClick={onClick}>
      <div className={styles['logo']}>
        <Image src={logo} borderRadius="0" />
      </div>
      <UIText2 as="p" textAlign="center">
        {title}
      </UIText2>
    </a>
  );
};
